
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import shoplist from '@/components/shoplist.vue';
	import Switch from '@/components/switch.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      shoplist,
			'slz-switch': Switch,
    }
  })

  export default class ProductList extends Vue {
    private show = false
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private showlist(){
      this.show = true
    }
    private delshop(i){
      this.editinfo.msg.list.splice(i,1)
    }
    private getshop(e){
      if(!e||!e.length){
        this.$message.error('请选择商品')
        return 
      }
      if(e.length > 200){
        this.$message.error('最多添加200件商品')
        return 
      }
      this.show = false
      this.editinfo.msg.list = e
    }
  }
